import { ComponentsStateContext } from 'lib/contexts/ComponentsState';
import { useContext } from 'react';

export const useComponentsState = () => {
  return useContext(ComponentsStateContext);
};
